import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IDirectory, IDirectoryObj } from './types/Directory-interface'

const directoryState = (state: RootState): IDirectory => state.directory

export const DirectoryPriorities = createSelector(
    [directoryState],
    (state): IDirectoryObj[] => state.Priorities,
)
export const DirectoryThemes = createSelector(
    [directoryState],
    (state): IDirectoryObj[] => state.Themes,
)
export const DirectoryError = createSelector(
    [directoryState],
    (state): string[] => state.errorDirectory,
)
export const DirectoryLastFetch = createSelector(
    [directoryState],
    (state): null | number => state.lastFetchTime,
)
export const DirectoryLoading = createSelector(
    [directoryState],
    (state): boolean => state.isLoadingDirectory,
)